import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { useCurrentExperienceTranslationsQuery } from "@/features/experience-curation/queries/useExperienceTranslationsQuery";
import { useCurrentRawSnapshotsQuery } from "@/features/experience-curation/queries/useRawSnapshotsQuery";
import { useHasCommercialFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { usePrimitiveModelWithChanges } from "@/features/core-shared/composables/usePrimitiveModelWithChanges";

export const useCurationMeetingPoint = defineStore("curation-location-meeting-point-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const translationsQuery = useCurrentExperienceTranslationsQuery();
  const rawSnapshotsQuery = useCurrentRawSnapshotsQuery();

  const initialValue = computed(() => translationsQuery.data.value?.meeting_point_details ?? "");
  const { model, hasChanges, isFilled, reset } = usePrimitiveModelWithChanges(initialValue);

  const isRequired = false;
  const isReadonly = computed(() => curationExperienceStore.isReadonly);
  const showRawFields = computed(() => curationExperienceStore.showRawFields);

  const rawMeetingPointDetails = computed(
    () => rawSnapshotsQuery.data.value?.rawSnapshot?.raw?.commercial?.meeting_point_details || ""
  );
  const publishedRawMeetingPointDetails = computed(
    () => rawSnapshotsQuery.data.value?.publishedRawSnapshot?.raw?.commercial?.meeting_point_details || ""
  );
  const hasUnpublishedChange = useHasCommercialFieldChange("meeting_point_details");

  return {
    id: "location.meeting-point",
    model,
    isRequired,
    isReadonly,
    isFilled,
    hasChanges,
    hasUnpublishedChange,
    showRawFields,
    rawMeetingPointDetails,
    publishedRawMeetingPointDetails,
    reset,
  };
});
